import React from 'react'

const SvgDataCheckOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M5.293 6.707a1 1 0 101.414-1.414 1 1 0 00-1.414 1.414z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.78 14H4v-4l13.755.001 1.103-1.102A3 3 0 0122 8.171V4c0-1.332-.67-2-2.01-2H4c-1.333 0-2 .667-2 2v15.92C2 21.307 2.667 22 4 22h7.818c-.319-.244-.614-.54-.87-.797l-.08-.08L9.743 20H4v-4l3 .001v-.01A2.996 2.996 0 017.78 14zM20 8H4V4l16 .001V8z'
    />
    <path d='M16.233 20H20v-3.764l2-1.999v5.683c0 1.387-.667 2.08-2 2.08h-5.83c.298-.232.575-.51.82-.758l.12-.12L16.232 20zM13.047 20h-.117a1.044 1.044 0 00.117 0zM5.293 12.707a1 1 0 101.414-1.414 1 1 0 00-1.414 1.414zM5.293 18.707a1 1 0 101.414-1.414 1 1 0 00-1.414 1.414z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M20.282 10.305a1 1 0 111.414 1.414l-8 8a1 1 0 01-1.414 0l-3.001-3a1 1 0 011.414-1.415l2.294 2.294 7.293-7.293z'
    />
  </svg>
)

export default SvgDataCheckOutline
